import React, { Component } from "react";
import request from "../../lib/requester";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      baseTable: [],
      user: JSON.parse(window.localStorage.getItem("is_user")) || {},
    };
  }

  componentDidMount = () => {
    let url = "/api/traces/v1/claim/list-approval";
    let orgId = this.state.user.org_id;
    let param = {
      org_id: orgId,
    };
    request.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MMM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MMM-YYYY");
          item.formatted_submitted_date = moment(item.creation_date).format(
            "DD-MMM-YYYY HH:mm:ss"
          );
          item.formatted_exp_date = moment(item.claim_exp_date).format(
            "DD-MMM-YYYY"
          );
          item.formatted_status = this.labelStatus(item);
          return item;
        });
        this.setState({ dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  labelStatus = (item) => {
    if (item.status === "A") {
      return "Approve";
    } else if (item.status === "R") {
      return "Rejected";
    } else if (item.status === "P") {
      return "Proposed";
    } else {
      return "No Status";
    }
  };

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable;
    let filename =
      "claim-approval-" + moment(new Date()).format("DDMMYYYYHHmmss");

    return (
      <ExcelFile
        filename={filename}
        fileExtension="xlsx"
        element={
          <button className="btn btn-success">
            <i className="fas fa-file-excel" /> Export To Excel
          </button>
        }
      >
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="CLAIM NO" value="claim_number" />
          <ExcelColumn label="REF NO" value="ref_number" />
          <ExcelColumn label="TRACES NO" value="skp_number" />
          <ExcelColumn label="PROGRAM TYPE" value="program_name" />
          <ExcelColumn label="DESCRIPTION" value="description" />
          <ExcelColumn label="BUDGET" value="budget" />
          <ExcelColumn label="START DATE" value="formatted_start_date" />
          <ExcelColumn label="END DATE" value="formatted_end_date" />
          <ExcelColumn label="CLAIM EXP DATE" value="formatted_exp_date" />
          <ExcelColumn
            label="SUBMITTED DATE"
            value="formatted_submitted_date"
          />
          <ExcelColumn label="CUSTOMER" value="customer_name" />
          <ExcelColumn label="STATUS" value="status" />
        </ExcelSheet>
      </ExcelFile>
    );
  };

  handleSearch = (e) => {
    let value = e.target.value;
    this.setState({ search: value });
    let baseTable = _.filter(this.state.baseTable, function (o) {
      return (
        (o.customer_name
          ? o.customer_name.toLowerCase().includes(value.toLowerCase())
          : "") ||
        o.description.toLowerCase().includes(value.toLowerCase()) ||
        o.org_name.toLowerCase().includes(value.toLowerCase()) ||
        o.program_number.toLowerCase().includes(value.toLowerCase()) ||
        o.ref_number.toLowerCase().includes(value.toLowerCase())
      );
    });
    this.setState({ dataTable: baseTable });
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "CLAIM NO",
          accessor: "claim_number",
          filterable: true,
        },
        {
          Header: "TRACES NO",
          accessor: "skp_number",
          filterable: true,
        },
        {
          Header: "REF NO",
          accessor: "ref_number",
          filterable: true,
        },
        {
          Header: "AWB NO",
          accessor: "awb_principal_no",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "program_name",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "description",
          filterable: true,
        },
        {
          Header: "BUDGET",
          accessor: "budget",
          className: "text-right",
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "START DATE",
          accessor: "start_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "END DATE",
          accessor: "end_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "CLAIM EXPIRED DATE",
          accessor: "claim_exp_date",
          Cell: (row) => (
            <span>
              <span>{moment(row.value).format("DD-MMM-YYYY")}</span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "SUBMITTED DATE",
          accessor: "creation_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "AMOUNT",
          accessor: "total",
          className: "text-right",
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "CUSTOMER",
          accessor: "customer_name",
          filterable: true,
        },
        {
          Header: "STATUS",
          accessor: "status",
          Cell: (row) => {
            let status = row.value;
            let newstatus = "";
            switch (status) {
              case "A":
                newstatus = "Approve";
                break;
              case "P":
                newstatus = "Propose";
                break;
              case "R":
                newstatus = "Reject";
                break;
              default:
                newstatus = "No Status";
                break;
            }
            return <span>{newstatus}</span>;
          },
          filterable: true,
        },
        {
          Header: "",
          accessor: "claim_id",
          Cell: (row) => {
            return (
              <span>
                <button
                  className="btn btn-info btn-sm"
                  onClick={() => {
                    this.goDetail(row);
                  }}
                >
                  <i className="fas fa-eye"></i> Edit
                </button>
              </span>
            );
          },
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = "";
          switch (filter.id) {
            case "start_date":
              columnes = row._original.formatted_start_date;
              break;
            case "end_date":
              columnes = row._original.formatted_end_date;
              break;
            case "claim_exp_date":
              columnes = row._original.formatted_exp_date;
              break;
            case "status":
              columnes = row._original.formatted_status;
              break;
            case "creation_date":
              columnes = row._original.formatted_submitted_date;
              break;
            default:
              columnes = row[filter.id];
          }

          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/claim/editclaim/" + row.claim_id);
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-6 float-left">
                        <div className="row">
                          {/* <div className="col-lg-6">
                                                        <input type="text" className="form-control" onChange={ this.handleSearch.bind(this) } placeholder="Search Program..." value={ this.state.search } />
                                                    </div> */}
                          <div className="col-lg-6">
                            {/* <button className="btn btn-success"><i className="fas fa-file-excel" /></button> */}
                            {this.exportToExcel()}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 float-right"></div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Summary;
